import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment-timezone'
import 'moment/locale/en-gb'
import {
  Card,
  Col,
  ContentSectionBlock,
  FormInput,
  FormInputDateRange,
  FormInputSelect,
  Row,
  Popup
} from 'camino-react'

import TimesheetsReportAccordion from './TimesheetsReportAccordion'
import UtilizationReportAccordion from './UtilizationReportAccordion'

import { cloudhelpGet } from 'Utilities/CloudHelp'
import LoadingSpinner from 'Components/LoadingSpinner'
import Alert from 'Components/Alert'

class TimesheetsReport extends React.Component {
  constructor (props) {
    super(props)

    this.datePickerOptions = {
      dateFormat: 'd M y',
      altInput: true,
      enableTime: false,
      altFormat: 'F j, Y',
      mode: 'range',
      locale: { firstDayOfWeek: 1 }
    }

    this.state = {
      reportType: 'timesheets',
      timesheets: props.timesheets,
      users: [],
      teams: [],
      dateFrom: props.activeFilters.start_time,
      dateTo: props.activeFilters.end_time,
      loading: false,
      alert: {
        show: false,
        type: 'info',
        text: ''
      }
    }
  }

  changeDateFilter (dates) {
    if (dates[0] && dates[1]) {
      this.setState({
        dateFrom: dates[0],
        dateTo: dates[1]
      })
    }
  }

  resetFilters = () => {
    const monthAgo = new Date()
    monthAgo.setMonth(monthAgo.getMonth() - 1)

    this.setState({
      loading: false,
      timesheets: [],
      queue: null,
      dateFrom: monthAgo,
      dateTo: new Date()
    })
  }

  applyFilters = () => {
    const { timesheetReportPath } = this.props
    const { dateFrom, dateTo, queue } = this.state
    const getParams = { report: { start_time: moment(dateFrom).startOf('day').utc(), end_time: moment(dateTo).endOf('day').utc(), queue_id: queue.value } }

    this.setState({ loading: true })

    cloudhelpGet(timesheetReportPath, getParams)
      .then((response) => {
        this.setState({
          loading: false,
          timesheets: response.data.timesheets
        })
      })
  }


  render () {
    const {
      timesheets,
      reportType,
      dateFrom,
      dateTo,
      loading,
      alert,
      queue
    } = this.state
    const { currentUserQueues } = this.props
    const currentTimesheetsByUsers = _.groupBy(timesheets, timesheet => timesheet.user_name)

    const userColumns = [
      { text: 'Start', accessor: 'start_time', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) },
      { text: 'End', accessor: 'end_time', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) },
      { text: 'Ticket', accessor: 'ticket_id' },
      { text: 'Hours', accessor: 'duration_hours' },
      { text: 'Chargeable?', accessor: 'chargeable', Cell: row => (row.value ? 'Yes' : 'No') },
      { text: 'Minutes deducted', accessor: 'utilization_deductable_minutes' },
      { text: 'Work type', accessor: 'workType' },
      { text: 'Work role', accessor: 'workRole' },
      {
        text: 'Description',
        accessor: 'description',
        minWidth: 250,
        Cell: row => (
          <Popup
            modal
            trigger={(
              <span style={{ cursor: 'pointer', color: '#00baea' }}>
                {row.original.description}
              </span>
            )}
          >
            <div className="popup-table-description">
              {row.original.description}
            </div>
          </Popup>
        )
      },
      { text: 'Note', accessor: 'comments' }
    ]

    const accordionDetails = {
      columns: userColumns,
      groupedTimesheets: currentTimesheetsByUsers
    }

    const accordion = () => {
      if (loading) {
        return <LoadingSpinner />
      } if (reportType === 'resourcesUtilization') {
        return (
          <UtilizationReportAccordion
            data={accordionDetails}
          />

        )
      }

      return (
        <TimesheetsReportAccordion
          data={accordionDetails}
        />
      )
    }

    return (
      <Card padding={false} allowOverflow>
        <ContentSectionBlock
          title="Filters"
          actions={[
            {
              onClick: this.applyFilters,
              text: 'Apply'
            },
            {
              onClick: this.resetFilters,
              text: 'Reset'
            }
          ]}
        >
          <Row>
            <Col>
              <FormInput label="Queue">
                <FormInputSelect
                  placeholder="Select ticket queue"
                  value={queue}
                  options={currentUserQueues}
                  onValue={value => this.setState({ queue: _.find(currentUserQueues, { value }) })}
                />
              </FormInput>
            </Col>

            <Col>
              <FormInput label="Date Range (inclusive)">
                <FormInputDateRange
                  id="timesheet_report_date_range"
                  onValue={date => (this.changeDateFilter(date))}
                  options={this.datePickerOptions}
                  value={[new Date(dateFrom), new Date(dateTo)]}
                  placeholder="Select..."
                />
              </FormInput>
            </Col>
          </Row>
        </ContentSectionBlock>

        <ContentSectionBlock title={_.isEmpty(timesheets) ? 'Apply filters to gather data' : `${queue.label} users timesheets reports`}>
          <Row>
            <Col>
              <Alert text={alert.text} alertType={alert.type} showAlert={alert.show} />
            </Col>
          </Row>
          <Row>
            <Col>
              {accordion()}
            </Col>
          </Row>
        </ContentSectionBlock>
      </Card>
    )
  }
}

TimesheetsReport.propTypes = {
  timesheets: PropTypes.arrayOf(PropTypes.object).isRequired,
  timesheetReportPath: PropTypes.string.isRequired,
  activeFilters: PropTypes.shape({
    start_time: PropTypes.string,
    end_time: PropTypes.string
  })
}

TimesheetsReport.defaultProps = {
  activeFilters: {
    start_time: new Date(),
    end_time: new Date()
  }
}

export default TimesheetsReport
